import axios from 'axios'
import { Message, Loading } from 'element-ui'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' 
    ? '/'  // 生产环境走同源Nginx反代（/api -> 后端）
    : '/',  // 开发环境使用代理
  timeout: 30000,
  withCredentials: true  // 关键：允许跨域请求携带Cookie，保持Session一致性
})

let loadingInstance = null

// 请求拦截器
service.interceptors.request.use(
  config => {
    console.log('request config:', config)
    // 支持通过config.showLoading控制loading，默认true
    if (config.showLoading !== false) {
      if (!loadingInstance) {
        loadingInstance = Loading.service({ fullscreen: true, text: '加载中...' })
      }
    }
    // 如果请求URL不以/api开头，则自动添加/api前缀
    if (!config.url.startsWith('/api')) {
      config.url = '/api' + (config.url.startsWith('/') ? config.url : '/' + config.url)
    }
    
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 关闭全局 loading
    if (loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
    const res = response.data
    // 如果返回的状态码不是200，说明接口有问题，应该提示
    if (res.code !== 200) {
      Message({
        message: res.message || '系统错误',
        type: 'error',
        duration: 3 * 1000
      })
      
      // 如果是未登录状态，清除token并跳转到登录页
      if (res.code === 401) {
        localStorage.removeItem('token')
        router.push('/login')
      }
      
      return Promise.reject(new Error(res.message || '系统错误'))
    }
    return res
  },
  error => {
    // 关闭全局 loading
    if (loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
    console.error('请求错误', error)
    
    // 处理网络连接错误（如代理连接失败）
    if (!error.response) {
      Message({
        message: '网络连接失败，请检查后端服务是否启动',
        type: 'error',
        duration: 5000
      })
      return Promise.reject(error)
    }
    
    // 处理 HTTP 状态码错误
    const status = error.response.status
    const errorMessage = error.response.data.message || '请求失败，请稍后重试'
    
    switch (status) {
      case 401:
        Message({
          message: '请先登录',
          type: 'warning',
          duration: 3 * 1000
        })
        // 清除token并跳转到登录页
        localStorage.removeItem('token')
        router.push('/login')
        break
      case 403:
        Message({
          message: '没有权限',
          type: 'warning',
          duration: 3 * 1000
        })
        break
      case 404:
        Message({
          message: '请求的资源不存在',
          type: 'error',
          duration: 3 * 1000
        })
        break
      default:
        Message({
          message: errorMessage,
          type: 'error',
          duration: 3 * 1000
        })
    }
    return Promise.reject(error)
  }
)

// 封装get/post等方法，支持showLoading参数
const request = (config) => service(config)
request.get = (url, config = {}) => service({ url, method: 'get', ...config })
request.post = (url, data = {}, config = {}) => service({ url, method: 'post', data, ...config })
request.put = (url, data = {}, config = {}) => service({ url, method: 'put', data, ...config })
request.delete = (url, config = {}) => service({ url, method: 'delete', ...config })
request.patch = (url, data = {}, config = {}) => service({ url, method: 'patch', data, ...config })
request.head = (url, config = {}) => service({ url, method: 'head', ...config })
request.options = (url, config = {}) => service({ url, method: 'options', ...config })
export default request 